import { CommonModule } from '@angular/common';
import { NgModule } from "@angular/core";
import { NgxPaginationModule } from 'ngx-pagination';
import { AgrBlockDataItemComponent } from './components/agr-block-data-item/agr-block-data-item.component';
import { AgrBlockListItemComponent } from './components/agr-block-list-item/agr-block-list-item.component';
import { AgrBlockListComponent } from './components/agr-block-list/agr-block-list.component';

@NgModule({
  declarations: [AgrBlockListComponent, AgrBlockListItemComponent, AgrBlockDataItemComponent],
  imports: [CommonModule, NgxPaginationModule],
  exports: [AgrBlockListComponent, AgrBlockDataItemComponent]
})
export class AgrBlockListModule {}
